<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <g clip-path="url(#clip0_127_970)">
      <path
        d="M11.8002 0.999951V8.59995C11.8002 8.81212 11.7159 9.01561 11.5659 9.16564C11.4159 9.31567 11.2124 9.39995 11.0002 9.39995H7.8002V10.6L8.5542 11.472C8.57854 11.5012 8.59404 11.5367 8.59889 11.5745C8.60374 11.6122 8.59772 11.6505 8.58156 11.685C8.56539 11.7194 8.53974 11.7485 8.50762 11.7689C8.4755 11.7892 8.43823 11.8 8.4002 11.8H3.6002C3.56216 11.8 3.52489 11.7892 3.49277 11.7689C3.46065 11.7485 3.435 11.7194 3.41883 11.685C3.40267 11.6505 3.39665 11.6122 3.4015 11.5745C3.40635 11.5367 3.42185 11.5012 3.4462 11.472L4.2002 10.6V9.39995H1.0002C0.788022 9.39995 0.584539 9.31567 0.43451 9.16564C0.284481 9.01561 0.200195 8.81212 0.200195 8.59995V0.999951C0.200195 0.787778 0.284481 0.584295 0.43451 0.434266C0.584539 0.284237 0.788022 0.199951 1.0002 0.199951H11.0002C11.2124 0.199951 11.4159 0.284237 11.5659 0.434266C11.7159 0.584295 11.8002 0.787778 11.8002 0.999951Z"
        fill="#FFBA00" />
      <path
        d="M10.8 1H1.2C1.08954 1 1 1.08954 1 1.2V8.4C1 8.51046 1.08954 8.6 1.2 8.6H10.8C10.9105 8.6 11 8.51046 11 8.4V1.2C11 1.08954 10.9105 1 10.8 1Z"
        fill="#4C8056" />
      <path d="M7.79971 9.40002V10.6H5.99971H4.19971V9.40002H7.79971Z" fill="#BD8E0F" />
    </g>
    <defs>
      <clipPath id="clip0_127_970">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
export default {};
</script>
